import React from 'react';
import PropTypes from 'prop-types';

import isEmpty from 'lodash/isEmpty';

import './Panel.styles.css';

/*
panel is used to wrap everything in a container
panels can be collapsible and have plenty of customization options, such as buttons, tabs, badges..
to close a panel, add the class .PanelCollapsed to .PanelWrapper and .Collapse to .PanelContainer
NOTE: collapsible functionality is active

panel header: section at the top of the panel; only thing showing when panel is collapsed
panel content: main content ie children; wrapped by PanelContainer which as a predefined padding

customClass: if provided, adds a custom class to the panel
*/

const Panel = props => {
  const {
    header, footer, panelToolbar, children, customClass, customBodyClass, disabled,
  } = props;

  return (
    <div className={`panel ${customClass}`} disabled={disabled}>
      {
        (header || panelToolbar)
        && (
          <div className="panel-hdr">
            {!isEmpty(header) ? (
              <>
                <h2>
                  {header}
                </h2>
              </>
            ) : null}
            {!isEmpty(panelToolbar) ? <div className="panel-toolbar">{panelToolbar}</div> : null}
          </div>
        )
      }
      {children && (
        <div className="panel-container">
          <div className={`panel-content ${customBodyClass} `}>
            {children}
          </div>
        </div>
      )}
      {!isEmpty(footer) && footer !== null ? <div className="panel-ftr">{footer}</div> : null}
    </div>
  );
};

Panel.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(), PropTypes.func]),
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(), PropTypes.func]),
  children: PropTypes.node,
  panelToolbar: PropTypes.node,
  customClass: PropTypes.string,
  customBodyClass: PropTypes.string,
  disabled: PropTypes.bool,
  // leave commented in case its needed again
  // children: PropTypes.oneOfType([
  //   PropTypes.arrayOf(PropTypes.node),
  //   PropTypes.node,
  // ]).isRequired,
};

Panel.defaultProps = {
  children: null,
  header: '',
  footer: '',
  panelToolbar: null,
  customClass: '',
  customBodyClass: '',
  disabled: false,
};

export default Panel;
